import { useEffect, useState } from 'react';

import { SubscriptionContext } from './subscription-context';
import { useAuth } from '../auth';
import { Tables, supabase } from '../supabase';

interface Props {
  children: React.ReactNode;
}

export const SubscriptionProvider = (props: Props) => {
  const { session } = useAuth();
  const [subscription, setSubscription] = useState<Tables<'subscriptions'> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!session?.user.id) {
      setLoading(false);
      setSubscription(null);
      return;
    }

    const doFetch = async () => {
      const { data, error } = await supabase
        .from('subscriptions')
        .select('*')
        // get most recent subscription
        .order('expiration_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) {
        console.log('SUBSCRIPTION ERROR', error);
        setLoading(false);
        // TODO: error handling and log
        //setError('Unable to retrieve subscription status');
        return;
      }

      setLoading(false);
      setSubscription(data);
    };

    doFetch();
  }, [session?.user.id]);

  return (
    <SubscriptionContext.Provider
      value={{
        subscription,
        get subscriptionActive() {
          if (!subscription) {
            return false;
          }

          // If a user has not cancelled, allow for grace period.
          // Since billing is done at exact current_period_end, give 7 days grace
          // for payments to go through for a nice user experience. This also covers
          // when a payment fails but user fixes by updating payment details in app stores etc.
          const gracePeriodDays = subscription.cancelled_at !== null ? 0 : 7;
          const gracePeriodMs = gracePeriodDays * 24 * 60 * 60 * 1000;
          const periodEndMs = new Date(subscription.expiration_at).getTime();
          const nowMs = Date.now();
          return periodEndMs + gracePeriodMs >= nowMs;
        },
        setSubscription: (newSubscription) => {
          // TODO: should this remain a client state setter only or also have the server call?
          setSubscription(newSubscription);
        },
      }}
    >
      {loading ? null : props.children}
    </SubscriptionContext.Provider>
  );
};
